

<div class="row justify-content-md-center en-tête p-0 m-0" *ngIf="appareilName == 'mails'">
    <h5 class="col-12 text-center pb-0 mb-0"> Mes Mails</h5>
    <div class="input-group col-9 p-1">
      <!-- <input type="search" class="form-control rounded" placeholder="Search" aria-label="Search" aria-describedby="search-addon" onkeyup="recherche()"/> -->
      <input type="text" id="inputMail" class="barreRecherche" (keyup)="rechercheMails()" placeholder="recherche.." title="Tapper ici un nom">

    </div>
  </div>

  <!-- Parite inferieur avec le groupe item -->
  <div class="row bodydashboard" *ngIf="appareilName == 'mails'">
    <ul class="list-group col-12 pr-0 overflow-auto mt-0 pt-0 listeRecherche" style="max-height:22vh" id="ulMail"  >
      <li class="list-group-item col-12  w-100 p-3 rounded-0" *ngFor="let item of tab, let i = index">
         <a id={{i}}  data-toggle="modal" data-target="#MailModal" (click)="setId($event)" href="#">{{tab[i].de}} {{tab[i].objet}} {{tab[i].date}} {{tab[i].heure}}</a>
      </li>
    </ul>
      <app-pop-up-info [info] = sendMail(ind) [modalName] = "name1"></app-pop-up-info>
  </div>

  <div class="row justify-content-md-center en-tête p-0 m-0" *ngIf="appareilName == 'docs'">
    <h5 class="col-12 text-center pb-0 mb-0"> Mes Documents</h5>
    <div class="input-group col-9 p-1">
      <input type="text" id="inputDocuments" class="barreRecherche" (keyup)="rechercheDocuments()" placeholder="recherche.." title="Tapper ici un nom">
    </div>
  </div>

  <!-- Parite inferieur avec le groupe item -->
  <div class="row bodydashboard" *ngIf="appareilName == 'docs'">
    <ul class="list-group col-12 pr-0 overflow-auto mt-0 pt-0 listeRecherche" style="max-height:22vh" id="ulDocuments" >
      <li class="list-group-item col-12  w-100 p-3 rounded-0" *ngFor="let item of tab, let i = index"> 
        <a id={{i}} data-toggle="modal" data-target="#DocModal"  (click)="setId($event)" href="#">{{tab[i].nom}} {{tab[i].date}} {{tab[i].type}}</a>
      </li>
      
    </ul>
    <app-pop-up-info [info] = sendDoc(ind) [modalName] = "name2"></app-pop-up-info>
  </div>

  